import {
  AUTOMOBILE_BODY_TYPES_HIDDEN_BY_DEFAULT,
  type AutomobileBodyType,
  type AutomobileModel,
} from '../types/automobile';

/** Varsayılan listede gizli gövde tipleri (yalnızca filtre seçilince gösterilir). */
export function isBodyTypeHiddenByDefault(bodyType: AutomobileBodyType): boolean {
  return (AUTOMOBILE_BODY_TYPES_HIDDEN_BY_DEFAULT as readonly string[]).includes(bodyType);
}

/** Site listesi: boş filtre = traktör/motosiklet hariç; filtre seçili = yalnızca o tip. */
export function filterModelsForBodyFilter(
  models: AutomobileModel[],
  bodyFilter: AutomobileBodyType | '',
): AutomobileModel[] {
  if (bodyFilter) {
    return models.filter((m) => m.bodyType === bodyFilter);
  }
  return models.filter((m) => !isBodyTypeHiddenByDefault(m.bodyType));
}

export function countModelsForBodyFilter(
  models: AutomobileModel[],
  bodyFilter: AutomobileBodyType | '',
): number {
  return filterModelsForBodyFilter(models, bodyFilter).length;
}
